import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { ControlledTextField } from '../../../../shared/components';
import PocDirectorySelect from './PocDirectorySelect';

export default function OwnerContactSection({ headerActions }) {
  const { setValue } = useFormContext();

  return (
    <div className='column'>
      <div className='row gap-5'>
        <Typography variant='body1' fontWeight={500} sx={{ whiteSpace: 'nowrap' }}>
          3. Owner Details
        </Typography>
        {headerActions}
      </div>

      <div className='grid grid--2-cols'>
        <PocDirectorySelect type='owner' path='owner' />
        {/* Supervisors are their own master and their own `supervisor_id` on the job. */}
        <PocDirectorySelect
          type='supervisor'
          path='owner'
          idPath='owner.supervisorId'
          label='Existing supervisor'
          applyRecord={(record) => {
            setValue('owner.supervisorId', record.id ?? null, { shouldDirty: true });
            setValue('owner.supervisorName', record.name ?? '', { shouldDirty: true });
            setValue('owner.supervisorContact', record.contact ?? '', { shouldDirty: true });
          }}
        />
      </div>

      <div className='grid grid--2-cols grid--with-divider'>
        <div className='column'>
          <ControlledTextField
            id='owner.name'
            name='owner.name'
            label='Full name'
            placeholder='Enter full name'
            rules={{
              minLength: { value: 3, message: 'Name must be at least 3 characters' },
              maxLength: { value: 100, message: 'Name cannot exceed 100 characters' },
            }}
          />
          <ControlledTextField
            id='owner.mobile'
            name='owner.mobile'
            label='Mobile number'
            placeholder='Enter mobile number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Mobile number must be 10 digits' },
              maxLength: { value: 10, message: 'Mobile number must be 10 digits' },
            }}
          />
          <ControlledTextField
            id='owner.email'
            name='owner.email'
            label='Email address'
            placeholder='Enter email ID'
            type='email'
            rules={{
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
              },
            }}
          />
          <ControlledTextField
            id='locality'
            name='locality'
            label='Locality'
            placeholder='Enter locality'
            rules={{
              required: 'Locality is required',
              maxLength: { value: 100, message: 'Locality cannot exceed 100 characters' },
              minLength: { value: 3, message: 'Locality should be at least 3 characters' },
            }}
          />
          <ControlledTextField
            id='owner.supervisorName'
            name='owner.supervisorName'
            label='Name of Supervisor'
            placeholder='Enter supervisor name'
            rules={{
              minLength: { value: 3, message: 'Supervisor name must be at least 3 characters' },
              maxLength: { value: 100, message: 'Supervisor name cannot exceed 100 characters' },
            }}
          />
        </div>

        {/* Right column */}
        <div className='column'>
          <ControlledTextField
            id='owner.phone'
            name='owner.phone'
            label='Phone number'
            placeholder='Enter phone number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Phone number must be 10 digits' },
              maxLength: { value: 10, message: 'Phone number must be 10 digits' },
            }}
          />
          <ControlledTextField
            id='owner.whatsapp'
            name='owner.whatsapp'
            label='WhatsApp number'
            placeholder='Enter WhatsApp number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
              maxLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
            }}
          />
          <div className='column'>
            <ControlledTextField
              id='siteAddress'
              name='siteAddress'
              label='Site address'
              placeholder='Enter site address'
              rules={{
                required: 'Site address is required',
                maxLength: { value: 300, message: 'Site address cannot exceed 300 characters' },
                minLength: { value: 3, message: 'Site address should be at least 3 characters' },
              }}
              isMultiline
            />
            <ControlledTextField
              id='owner.buildingName'
              name='owner.buildingName'
              label='Building name'
              placeholder='Enter building name'
              rules={{
                minLength: { value: 1, message: 'Building ame must be at least 1 characters' },
                maxLength: { value: 100, message: 'Building name cannot exceed 100 characters' },
              }}
            />
            <ControlledTextField
              id='owner.supervisorContact'
              name='owner.supervisorContact'
              label='Contact number of Supervisor'
              placeholder='Enter supervisor contact number'
              inputMode='numeric'
              rules={{
                minLength: { value: 10, message: 'Supervisor contact number must be 10 digits' },
                maxLength: { value: 10, message: 'Supervisor contact number must be 10 digits' },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
